function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { cloneDeep, filter, map } from 'lodash';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
import { MainQuestion } from 'src/_candidato/data/main-question';
import { TiposDocEstadosStore } from 'src/_candidato/data/tiposStore';
import { BaseFiltrosComponent } from '../_base/base-filtros.component';
import { FILTROS, FILTRO_DEFECTO } from '../_base/filtros';
import './lista-mis-form-internos.scss';
import { tap } from 'rxjs';
var ListaMisFormInternosComponentCtrl = /*#__PURE__*/function (_BaseFiltrosComponent) {
  ListaMisFormInternosComponentCtrl.$inject = ["$element", "$log", "$timeout", "AccesoDatos", "appConfigService"];
  function ListaMisFormInternosComponentCtrl($element, $log, $timeout, AccesoDatos, appConfigService) {
    var _this;
    _classCallCheck(this, ListaMisFormInternosComponentCtrl);
    _this = _callSuper(this, ListaMisFormInternosComponentCtrl, [$log, appConfigService]);
    _defineProperty(_this, "$loading", false);
    _defineProperty(_this, "panelcv", {
      $visible: false,
      cv: null
    });
    _defineProperty(_this, "paneleditcv", {
      $visible: false,
      cv: null
    });
    _defineProperty(_this, "mostrarTotal", false);
    _defineProperty(_this, "total", {
      count: 0,
      valid: false
    });
    _defineProperty(_this, "buscarPublicos", true);
    _defineProperty(_this, "exited", false);
    _this.$element = $element;
    _this.$timeout = $timeout;
    _this.AccesoDatos = AccesoDatos;
    _this.autoUnsub(
    //
    _this._flags.pipe(tap(function (flags) {
      _this.mostrarTotal = flags.esAppCandidato;
    })).subscribe());
    return _this;
  }
  _inherits(ListaMisFormInternosComponentCtrl, _BaseFiltrosComponent);
  return _createClass(ListaMisFormInternosComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      this.$log.info('[ListaMisFormInternosComponentCtrl] onInit');
      this.filtrosList = cloneDeep(FILTROS);
      this.activaFiltro(this.filtrosList[0]);
      this.AccesoDatos.Datos_Client.tiposParaDocuemntos().then(function (tiposResponse) {
        return _this2.datosTipos = new TiposDocEstadosStore(tiposResponse);
      });
      this.totalesCall = this.$timeout(function () {
        return _this2.actualizaTotales();
      }, 1000);
      this.mainQCall = this.$timeout(function () {
        return _this2._actualizaMainQ();
      }, 5000);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      // this.$timeout.cancel(this.selectUpdate)

      this.mainQCall && this.$timeout.cancel(this.mainQCall);
      this.totalesCall && this.$timeout.cancel(this.totalesCall);
      this.exited = true;
    }
  }, {
    key: "actualizaTotales",
    value: function actualizaTotales() {
      var _this3 = this;
      this.AccesoDatos.GestionSolicitudes_CLIENT.totalCV().then(function (responseResumen) {
        if (responseResumen.valid) {
          _this3.total.valid = true;
          _this3.total.count = responseResumen.totalValid;
        } else _this3.total.valid = false;
      });
    }
  }, {
    key: "_actualizaMainQ",
    value: function _actualizaMainQ() {
      var _this4 = this;
      if (this.exited) return;
      if (!this.mainq.$load) {
        this.mainq.$load = this.AccesoDatos.MainQuestions_CLIENT.todasLasPregPrincipales();
        this.mainq.$load.then(function (responseList) {
          // solo las que permiten búsqueda
          _this4.mainq.list = map(filter(responseList, function (mq) {
            return mq.usar_busquedas;
          }), function (mq) {
            return new MainQuestion(mq);
          });
        }).then(function () {
          // establecer el primero
          if (_this4.mainq.list.length) {
            _this4.filtroQ.mainq = _this4.mainq.list[0].data_mq.idmainq;
          }
          _this4._updateSelect();
        });
      }
    }
  }, {
    key: "_busqueda",
    value: function _busqueda() {
      var _this5 = this;
      // al inicio, obtener los ítems de menú disponibles, no solo los visibles
      var filtros;
      if (this.filtros) {
        var _filtrosBusqueda = this.filtroActivo && this.filtroActivo.filtros(this) || cloneDeep(FILTRO_DEFECTO);
        if (this.buscarPublicos) _filtrosBusqueda.listarPublicos = true;
        filtros = this.AccesoDatos.GestionSolicitudes_CLIENT.listCV(_filtrosBusqueda);
      } else filtros = this.AccesoDatos.GestionSolicitudes_CLIENT.lastCV();
      filtros.then(function (listadoResponse) {
        _this5.$log.info('listado', listadoResponse);
        _this5.listado = null;
        _this5.listadolist = null;
        _this5.$timeout(function (_) {
          _this5.listado = listadoResponse;
          _this5.listadolist = listadoResponse.list;
        });
      });
    }
  }, {
    key: "accessfi",
    value: function accessfi(idx) {
      this.$log.debug('access', this.listado.list[idx]);
      this.panelcv.cv = this.listado.list[idx];
      this.panelcv.$visible = true;
    }
  }, {
    key: "accessEditfi",
    value: function accessEditfi(idx) {
      this.$log.debug('access edit', this.listado.list[idx]);
      this.paneleditcv.cv = this.listado.list[idx];
      this.paneleditcv.$visible = true;
    }
  }, {
    key: "_updateSelect",
    value: function _updateSelect() {
      var _this6 = this;
      if (this.exited) return;
      this.$timeout(function () {
        return _this6.$element.find('select').formSelect();
      }, 100);
    }
  }, {
    key: "seleccionaMainQ",
    value: function seleccionaMainQ() {
      this.$log.info('=============');
    }
  }, {
    key: "activaFiltro",
    value: function activaFiltro(f) {
      var _this$filtroActivo;
      ((_this$filtroActivo = this.filtroActivo) === null || _this$filtroActivo === void 0 ? void 0 : _this$filtroActivo.onend) && this.filtroActivo.onend(this);
      this.filtroActivo = f;
      f.onactivate(this);
    }
  }, {
    key: "updateAccionCV",
    value: function updateAccionCV(cvdata) {
      this._updateAccion(cvdata, this.panelcv);
    }
  }, {
    key: "updateAccionEditCV",
    value: function updateAccionEditCV(cvdata) {
      this._updateAccion(cvdata, this.paneleditcv);
    }
  }, {
    key: "_updateAccion",
    value: function _updateAccion(cvdata, _panel) {
      this.$log.info(' update!!!!!!', cvdata);
      var _actualcv = _panel.cv;
      if (_actualcv) {
        _actualcv.cv.estado = cvdata.actionitem.state;
        _actualcv.cv.fcrevision = cvdata.actionitem.fc;
      }
    }
  }]);
}(BaseFiltrosComponent);
angular.module('candidato').component('listaMisFormInternos', {
  bindings: {
    filtros: '<'
  },
  controller: ListaMisFormInternosComponentCtrl,
  // templateUrl: "lista-mis-form-internos.component.html",
  template: require('./lista-mis-form-internos.component.html')
});